import { render } from "./PixelSun.vue?vue&type=template&id=a3abd112"
import script from "./PixelSun.vue?vue&type=script&lang=js"
export * from "./PixelSun.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__